module.exports = __webpack_public_path__ + "media/generic_scholarship_search/fastweb-logo-9566d9ad.png";